import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "text-text-neutral-medium px-8 py-10 max-w-[1440px] w-full" }
const _hoisted_3 = { class: "text-lg md:text-3xl font-semibold flex gap-2 relative flex items-center justify-center md:justify-start" }
const _hoisted_4 = { class: "mt-6 flex items-center gap-1 border-b border-stroke-separator" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = ["href", "onClick"]

import MainFooter from "@/components/MainFooter.vue";
import emitter from "@/services/emitter.service";
import { Constants } from "@/cfg/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationView',
  setup(__props) {

const customVocabEnabled = Constants.CUSTOM_VOCAB_ENABLED;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createElementVNode("span", {
            class: "absolute left-0 flex md:hidden items-center",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_unref(emitter).emit('open-account-popup');}, ["prevent"]))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M13.0893 4.41074C13.4147 4.73618 13.4147 5.26382 13.0893 5.58926L8.67851 10L13.0893 14.4107C13.4147 14.7362 13.4147 15.2638 13.0893 15.5893C12.7638 15.9147 12.2362 15.9147 11.9107 15.5893L6.91074 10.5893C6.58531 10.2638 6.58531 9.73618 6.91074 9.41074L11.9107 4.41074C12.2362 4.08531 12.7638 4.08531 13.0893 4.41074Z",
                fill: "#6CBFFF"
              })
            ], -1)
          ]))]),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Manage organization", -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-2 text-gray-400 text-xs md:text-sm max-w-2xl" }, " Manage your team members access to premium features and view usage data. You can add or revoke access anytime. ", -1)),
        _createElementVNode("nav", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/organization",
            custom: ""
          }, {
            default: _withCtx(({ href, navigate, isExactActive }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                class: _normalizeClass(["px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors", isExactActive
                ? 'border-elements-blue text-text-neutral-extreme'
                : 'border-transparent text-text-neutral-medium hover:text-text-neutral-extreme'])
              }, " Members ", 10, _hoisted_5)
            ]),
            _: 1
          }),
          (_unref(customVocabEnabled))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/organization/vocabulary",
                custom: ""
              }, {
                default: _withCtx(({ href, navigate, isActive }) => [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate,
                    class: _normalizeClass(["px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors", isActive
                ? 'border-elements-blue text-text-neutral-extreme'
                : 'border-transparent text-text-neutral-medium hover:text-text-neutral-extreme'])
                  }, " Custom Vocabulary ", 10, _hoisted_6)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(MainFooter)
  ], 64))
}
}

})